import {validateAnimalRegistry} from './animal-registry-contract.js';
import {THREE_ANIMAL_BINDINGS} from './animal-registry-three-bindings.js';
/** Narrow Three-loader adapter. Generic entries never contain renderer objects. */
export function toWildlifeManifest(registry,bindings=THREE_ANIMAL_BINDINGS){
 validateAnimalRegistry(registry);
 return registry.entries.flatMap(entry=>entry.variants.map(variant=>{
  const result={family:entry.family};
  for(const [mode,selection]of[['full','standard'],['proxy','fallback']]){
   const lod=variant.assets.lods.find(lod=>lod.id===variant.selectedLods[selection]);
   const definition=bindings[lod.sha256];
   if(lod.triangles===undefined||lod.triangles>entry.runtime.budgets[mode==='full'?'standardTriangles':'fallbackTriangles'])throw new TypeError(`Geometry budget exceeded for ${variant.id}/${lod.id}`);
   if(!definition||definition.family!==entry.family)throw new TypeError(`Missing reviewed Three binding for ${variant.id}/${lod.id}`);
   if(!/^assets\/wildlife\/[a-z0-9_-]+\.glb$/.test(lod.path))throw new TypeError(`Unsupported Three payload path for ${variant.id}`);
   if(definition.variant!==undefined){if(result.variant!==undefined&&result.variant!==definition.variant)throw new TypeError('Primary/proxy variant binding mismatch');result.variant=definition.variant;}
   result[mode]={file:lod.path.split('/').at(-1),sha256:lod.sha256,bytes:lod.bytes,definition:structuredClone(definition)};
  }
  return result;
 }));
}
/** Existing live focus population, chosen without moving or creating residents. */
export function findCatalogResident(registry,items,{family,variantId}){
 const entry=registry.entries.find(entry=>entry.family===family),variant=entry?.variants.find(variant=>variant.id===variantId);
 if(!variant)return null;
 const lod=variant.assets.lods.find(lod=>lod.id===variant.selectedLods.standard),binding=THREE_ANIMAL_BINDINGS[lod.sha256];
 return items.find(item=>item.animal?.birdPlan?.safe!==false&&item.family===family&&(binding?.variant===undefined||item.animal?.variant%3===binding.variant))??null;
}

/** Per-seed placement diagnostics are separate from asset load/review status. */
export function catalogPopulationFor(world,family){
 const residents=family==='firefly'?(world.fireflyOrigins??[]):['deer','rabbit','fish'].includes(family)?(world.animals?.rigs??[]).map(r=>r.animal).filter(a=>a.type===family):(world.biodiversity?.data?.fauna??[]).filter(a=>a.type===family);
 const omitted=residents.filter(a=>a.birdPlan?.safe===false).map(a=>({id:a.id,reason:a.birdPlan.reason||'No safe placement found'}));
 return{requested:residents.length,placed:residents.length-omitted.length,omitted};
}
